import { gql } from '@apollo/client';

import { CartTriggerFragment } from '../Header/cartTriggerFragments.gql';
import { MiniCartFragment } from '../MiniCart/miniCartFragments.gql';

export const ADD_PRODUCT_TO_CART = gql`
  mutation AddProductToCart($cartId: String!, $product: CartItemInput!) {
    addProductsToCart(cartId: $cartId, cartItems: [$product]) {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
      }
    }
  }
  ${CartTriggerFragment}
  ${MiniCartFragment}
`;

export const GET_WISHLIST_CONFIG = gql`
  query GetWishlistConfigForProductMOS {
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    storeConfig {
      store_code
      product_url_suffix
      magento_wishlist_general_is_enabled
    }
  }
`;

/**
 * @deprecated - replaced by general mutation in @/hooks/productFullDetail.js
 */
export const ADD_CONFIGURABLE_MUTATION = gql`
  mutation addConfigurableProductToCart(
    $cartId: String!
    $quantity: Float!
    $sku: String!
    $parentSku: String!
    $product_image: String!
    $is_try_on: Int
    $try_on_order_item_id: ID
    $try_on_map_sku: String
    $robes_gifts_customization: [String]
    $color_price: Float
  ) {
    addConfigurableProductsToCart(
      input: {
        cart_id: $cartId
        cart_items: [
          {
            data: { quantity: $quantity, sku: $sku }
            parent_sku: $parentSku
            product_image: $product_image
            color_price: $color_price
            is_try_on: $is_try_on
            try_on_order_item_id: $try_on_order_item_id
            try_on_map_sku: $try_on_map_sku
            robes_gifts_customization: $robes_gifts_customization
          }
        ]
      }
    ) {
      cart {
        id
        # Update the cart trigger when adding an item.
        ...CartTriggerFragment
        # Update the mini cart when adding an item.
        ...MiniCartFragment
      }
    }
  }
  ${CartTriggerFragment}
  ${MiniCartFragment}
`;

export const ADD_SIMPLE_MUTATION = gql`
  mutation addSimpleProductToCart(
    $cartId: String!
    $quantity: Float!
    $sku: String!
    $customizable_options: [CustomizableOptionInput]
    $agreement: String
    $bust: String
    $category_id: Int
    $category_name: String
    $customize_price: Int
    $customsize: String
    $data_sku: String
    $dresseshemline: String
    $extralength: String
    $height: String
    $hip: String
    $hollowtoHem: String
    $hollowtoFloor: String
    $length: String
    $pockets: String
    $back_detail: String
    $product_color: String
    $product_image: String
    $shipingtypes: String
    $unit: String
    $waist: String
    $watermark: String
    $is_try_on: Int
    $try_on_order_item_id: ID
    $try_on_map_sku: String
    $robes_gifts_customization: [String]
    $color_price: Float
    $select_custom_rule: [String]
    $weboSku: String
  ) {
    addSimpleProductsToCart(
      input: {
        cart_id: $cartId
        cart_items: [
          {
            data: { quantity: $quantity, sku: $sku }
            customizable_options: $customizable_options
            agreement: $agreement
            bust: $bust
            category_id: $category_id
            category_name: $category_name
            customize_price: $customize_price
            customsize: $customsize
            data_sku: $data_sku
            dresseshemline: $dresseshemline
            extralength: $extralength
            height: $height
            hip: $hip
            hollowtoFloor: $hollowtoFloor
            hollowtoHem: $hollowtoHem
            length: $length
            pockets: $pockets
            back_detail: $back_detail
            product_color: $product_color
            product_image: $product_image
            color_price: $color_price
            shipingtypes: $shipingtypes
            unit: $unit
            waist: $waist
            watermark: $watermark
            is_try_on: $is_try_on
            try_on_order_item_id: $try_on_order_item_id
            try_on_map_sku: $try_on_map_sku
            robes_gifts_customization: $robes_gifts_customization
            select_custom_rule: $select_custom_rule
            weboSku: $weboSku
          }
        ]
      }
    ) {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
      }
    }
  }
  ${CartTriggerFragment}
  ${MiniCartFragment}
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  addConfigurableProductToCartMutation: ADD_CONFIGURABLE_MUTATION,
  addProductToCartMutation: ADD_PRODUCT_TO_CART,
  addSimpleProductToCartMutation: ADD_SIMPLE_MUTATION,
  getWishlistConfigQuery: GET_WISHLIST_CONFIG,
};
